import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { entityOfType } from "../../utils/system-entities";
import { SystemEntity } from "@erp/shared-types";

export const ingestMicrosoftGraphEmailStep = defineStepConfig({
  type: "ingest_microsoft_graph_email",
  name: "Ingest Microsoft Graph Email",
  description:
    "Pass through an existing InboundEmail record and its documents to downstream steps",
  category: "Integration",
  deprecated: {
    reason:
      "Document attachment output and origin detection are built into the Event Trigger node",
    replacedBy: "event_trigger",
  },

  inputSchema: z.object({
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL),
  }),

  outputSchema: z.object({
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL).optional(),
    documents: z.array(entityOfType(SystemEntity.CORE_DOCUMENT)),
    attachmentCount: z.number(),
    // Email origin metadata for downstream routing (e.g., reply detection)
    originType: z.string().optional(),
    conversationId: z.string().optional(),
    // Early exit convention for workflow completion
    _workflowComplete: z.boolean().optional(),
    _workflowCompleteReason: z.string().optional(),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "2 minutes",
    retry: {
      maximumAttempts: 3,
    },
    nonRetryableErrorTypes: ["ErrorItemNotFound", "ErrorAccessDenied"],
  },
});
